function serialize(obj: Record<string | number, string | number | boolean>): string {
    const pairings: Array<string> = [];

    for (const key of Object.keys(obj)) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            pairings.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    }

    const body = pairings.join('&');

    return body;
}

const module = {
    serialize,
};

export default module;
